export default __webpack_public_path__ + "static/media/2345.b94a4a1d.png";